export default {"src":"/_next/static/media/add-alt.d9257da7.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};